import { Component,  Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'image-placeholder',
    template: `
<icon *ngIf="!!icon" [icon]="'scenic'"></icon>
<div class="text">{{ text }}</div>
`,
    styleUrls: ['image-placeholder.scss'],
    standalone: true,
    imports: [IconComponent, CommonModule],
})
export class ImagePlaceholderComponent {
  @Input() icon: string
  @Input() text: string
}

